import { render, staticRenderFns } from "./buyList.vue?vue&type=template&id=2256769c&scoped=true"
import script from "./buyList.vue?vue&type=script&lang=js"
export * from "./buyList.vue?vue&type=script&lang=js"
import style0 from "./buyList.vue?vue&type=style&index=0&id=2256769c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2256769c",
  null
  
)

export default component.exports